var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sui-container',[_c('h3',{staticClass:"sui-header"},[_vm._v("Form CRS")]),_c('p',[_vm._v(" Read and/or download "),_c('a',{attrs:{"href":_vm.documentUrl,"target":"_blank"},on:{"click":_vm.updateSalesforceContact}},[_c('strong',[_vm._v("Form CRS")])]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }